import React, { RefObject } from 'react';
import styled, { css } from 'styled-components';
import { DragElementWrapper } from 'react-dnd';

export type justifyContentType =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'initial'
  | 'inherit';
export type alignItemsType =
  | 'stretch'
  | 'center'
  | 'flex-start'
  | 'flex-end'
  | 'baseline'
  | 'initial'
  | 'inherit';

export interface FlexProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  id?: string;
  innerRef?: RefObject<HTMLDivElement> | DragElementWrapper<any>;
  children?: any;
  className?: string;
  onClick?: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  justifyContent?: justifyContentType;
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  alignItems?: alignItemsType;
  flexGrow?: number | string;
  flexShrink?: number | string;
  flexBasis?: number | string;
  flex?: string;
  padding?: string;
  margin?: string;
  columnMobile?: boolean;
  gap?: number;
}

export const Flex: React.FC<FlexProps> = (props) => (
  <div
    id={props.id}
    className={props.className}
    style={{ ...props.style }}
    ref={props.innerRef}
    onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
  >
    {props.children || ''}
  </div>
);

export default styled(Flex)`
  display: flex;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  flex-direction: ${(props) => props.flexDirection || 'row'};
  flex: ${(props) => props.flex || '0 1 auto'};
  flex-grow: ${(props) => props.flexGrow || 0};
  flex-basis: ${(props) => props.flexBasis || 'auto'};
  flex-shrink: ${(props) => props.flexShrink || 1};
  flex-wrap: ${(props) => props.flexWrap || 'nowrap'};
  flex: ${(props) => props.flex || '0 1 auto'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  ${(props) =>
    props.margin
      ? css`
          margin: ${props.margin};
        `
      : null};

  ${(props) =>
    props.gap
      ? css`
          gap: ${props.gap}px;
        `
      : null};

  ${(props) =>
    props.padding
      ? css`
          padding: ${props.padding};
        `
      : null};

  ${(props) =>
    props.columnMobile
      ? css`
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          ${({ theme }) => `@media screen and ${theme.device.mobileL}`} {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        `
      : null};
`;
